import React from 'react';
import { formatNumber } from '../../../../utils/formatNumber';
import { NavLink } from 'react-router-dom';
import { calcFieldsValue } from '../../../../utils/calculateOfferFieldsValue';
import { ToolTip } from '../../../../components/Tooltip';

const AuctionData = ({
  isAdmin,
  currency,
  offerUserID,
  offer_user_firstname,
  offer_user_lastname,
  getCalcFieldData,
  userID,
  internal,
  external,
  scope,
  sharesPrice,
  
}) => {
  const fieldsData = getCalcFieldData();
  const calcFieldValues = fieldsData ? calcFieldsValue(fieldsData) : "";
  const show =  isAdmin() ? true : +offerUserID === +userID;
  const isExternal = scope === "EXTERNAL";
  const startPrice = isExternal ? external?.min : internal?.min;
  const data = [
    { title: 'User', condition: isAdmin(), value: `${offer_user_firstname} ${offer_user_lastname}`, offerUserID },
    { title: '% of HoldCo. Owned', condition: true, value: calcFieldValues.SPV },
    { title: '% of OpCo. Owned', condition: true, value: calcFieldValues.operatingCompanyOwned },
    { title: 'Your Investment', condition: show, value: `${formatNumber(calcFieldValues.finalAmount)} ${currency}` },
    { title: 'Distributions Received', condition: show, value: formatNumber(calcFieldValues.distributions) },
    { title: '% ROI', tooltip: 'Implied using list price', condition: show, value: calcFieldValues.ROI },
    { title: '% Annualized ROI', tooltip: 'Implied using list price', condition: show, value: calcFieldValues.ROIAnnualized },
    { title: '% Return On Distributions And Expected Proceeds', tooltip: 'Implied using list price', condition: show, value: calcFieldValues.RDE },
    { title: '% Annualized Return On Distributions And Expected Proceeds', tooltip: 'Implied using list price', condition: show, value: calcFieldValues.RDEAnnualized },
    { title: 'Starting Value', condition: true, value: startPrice ? `${formatNumber(startPrice)} ${isExternal ? currency : ''}` : "-" },
    { title: 'Price per Share', condition: true, value: sharesPrice ? `${formatNumber(sharesPrice)} ${currency}` : "-" },
  ];

  return (
    <div className='project_data' >
      {
        data.map((item, index) => (
          item.condition
            ? (
              <div key={index} className='medium-flex-container align-justify project_data_row' >
                <div className='text font-medium color-grey project_data_col' >
                  {item.title}
                  {item.tooltip && <ToolTip placement="rightTop" title={item.tooltip} />}
                </div>
                {
                  item.offerUserID
                    ? (
                      <NavLink
                        style={{ textDecoration: 'underline' }}
                        to={`/admin-users-inner/${item.offerUserID}`}
                        className='text font-bold color-grey project_data_col'
                      >
                        {item.value}
                      </NavLink>
                    )
                  : (
                      <div className='text font-bold color-grey project_data_col'>
                        {item.value}
                      </div>
                    )
                }
              </div>
            )
            : null
        ))
      }
    </div>
  );
};

export default AuctionData;
